import React, { Component } from "react";

class Line extends Component {
  render() {
    return <div className="container line" />;
  }
}

export default Line;
